import React, { useEffect, useState, useCallback } from 'react';
import { Truck, Maximize2 } from 'lucide-react';
import { BarChart, Bar, ResponsiveContainer } from 'recharts';
import ExpedicaoTotal from './ExpedicaoTotal';

const MiniChart = ({ color }) => {
  const data = Array.from({ length: 10 }, () => ({ val: Math.random() * 100 }));
  return (
    <div className="h-8 w-20 opacity-30">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <Bar dataKey="val" fill={color} radius={[1, 1, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

  
function StatBox({ title, icon: Icon, color, border, dia, mes, maior, onExpand }) {
  return (
    <div className={`relative bg-[#161b22] border-l-4 ${border} p-5 rounded shadow-xl flex flex-col justify-between h-full transition-all hover:bg-[#1c222a]`}>
      {/* Botão de Expansão */}
      <button
        onClick={onExpand}
        className="absolute top-3 right-3 text-gray-600 hover:text-orange-400 transition-colors z-20"
      >
        <Maximize2 size={16} />
      </button>

      <div className={`flex items-center gap-2 mb-6 ${color} font-black text-[10px] uppercase tracking-widest`}>
        <Icon size={24} /> <span>{title}</span>
      </div>

      <div className="flex justify-between items-end mb-4">
        <div>
          <p className="text-gray-500 text-[9px] font-bold uppercase mb-1 italic">Dia</p>
          <p className="text-white font-mono text-2xl font-bold italic tracking-tighter">
            R$ {Number(dia).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
        <MiniChart color="#fb923c" />
      </div>

      <div className="border-t border-gray-800 pt-3">        
        <div className="flex justify-between items-center">
          <p className="text-gray-500 text-[9px] font-bold uppercase italic">Mês</p>
          <p className={`${color} font-mono text-lg font-bold italic tracking-tighter`}>
            R$ {Number(mes).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>         
      </div>
    </div>
  );
}

export default function Expedicao(refreshSignal) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const base_url = 'https://onboard.fck.ind.br';

  const fetchData = useCallback(async () => {
    const token = localStorage.getItem('@user_token');
    fetch(`${base_url}/api/dashboard/expedicao`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
      .then(res => res.json())
      .then(json => {
        setData(Array.isArray(json) ? json[0] : json);
        setLoading(false);
        console.log("Dados de expedição atualizados.");
      })
      .catch(err => {
        console.error("Erro Expedição:", err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
      fetchData();
    }, [fetchData, refreshSignal]);

  if (loading) return (
    <div className="bg-[#161b22] border-l-4 border-orange-500 p-5 rounded animate-pulse h-[180px]">
      <div className="h-4 bg-gray-800 rounded w-1/2 mb-4"></div>
      <div className="h-8 bg-gray-800 rounded w-3/4"></div>
    </div>
  );

  return (
    <>
      <StatBox
        title="EXPEDIÇÃO"
        icon={Truck}
        color="text-orange-400"
        border="border-orange-500"
        dia={data?.totalExpedicaoDia || 0}
        mes={data?.totalExpedicao || 0}
        maior={data?.valor_totalmaior || 0}
        onExpand={() => setIsModalOpen(true)}
      />

      {isModalOpen && (
        <ExpedicaoTotal
          data={data}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
}